import { EmptyStringValidatorDirective } from './universal/universal.directive';
import { NgModule } from '@angular/core';
import { CreditCardValidatorDirective } from './creditcard/creditcard.directive';
import { EmailValidatorDirective } from './email/email.directive';
import { IsInRangeValidatorDirective, IsNumberValidatorDirective, MaxValidatorDirective, MinValidatorDirective, WhiteSpaceValidatorDirective } from './universal/universal.directive';
import { PasswordValidatorDirective } from './password/password.directive';
import { PhoneValidatorDirective, PossiblePhoneValidatorDirective, CountryCodeValidatorDirective } from './phone/phone.directive';
var ValidatorsModule = (function () {
    function ValidatorsModule() {
    }
    return ValidatorsModule;
}());
export { ValidatorsModule };
ValidatorsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [CreditCardValidatorDirective,
                    EmailValidatorDirective,
                    PasswordValidatorDirective,
                    IsInRangeValidatorDirective,
                    IsNumberValidatorDirective,
                    MaxValidatorDirective,
                    MinValidatorDirective,
                    WhiteSpaceValidatorDirective,
                    PhoneValidatorDirective,
                    PossiblePhoneValidatorDirective,
                    EmptyStringValidatorDirective,
                    CountryCodeValidatorDirective],
                exports: [CreditCardValidatorDirective,
                    EmailValidatorDirective,
                    PasswordValidatorDirective,
                    IsInRangeValidatorDirective,
                    IsNumberValidatorDirective,
                    MaxValidatorDirective,
                    MinValidatorDirective,
                    WhiteSpaceValidatorDirective,
                    PhoneValidatorDirective,
                    PossiblePhoneValidatorDirective,
                    EmptyStringValidatorDirective,
                    CountryCodeValidatorDirective]
            },] },
];
/** @nocollapse */
ValidatorsModule.ctorParameters = function () { return []; };
//# sourceMappingURL=validators.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-validators/src/validators.module.js
// module id = null
// module chunks = 